import { Button, Divider, Stack, styled, Typography } from "@mui/material";
import { FlexBox } from "@/components/baseComponents/FlexBox";

export const StyledContainer = styled(Stack)(({ theme }) => ({
  flexDirection: "column",
  maxWidth: "1200px",
  padding: "24px",
  gap: "16px",
  backgroundColor: theme.palette.common.white,
  borderRadius: "12px",

  [theme.breakpoints.down("desktop")]: {
    padding: "16px",
  },
}));

export const StyledHeader = styled(FlexBox)(({ theme }) => ({
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: "16px",

  [theme.breakpoints.down("tablet")]: {
    flexDirection: "column",
    alignItems: "stretch",
  },
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h5,
  color: theme.palette.primary.main,
}));

export const StyledHeaderButtons = styled(FlexBox)(() => ({
  gap: "12px",
}));

export const StyledSecondaryButton = styled(Button)(({ theme }) => ({
  ...theme.typography.h6,
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.secondary.contrastText,
  padding: "8px 16px",
  borderRadius: "6px",
  "&:hover": {
    backgroundColor: theme.palette.secondary.dark,
  },
}));

export const StyledContentWrapper = styled(FlexBox)(({ theme }) => ({
  flexDirection: "row",
  rowGap: "16px",
  columnGap: "40px",
  alignItems: "stretch",

  [theme.breakpoints.down("desktop")]: {
    flexDirection: "column",
  },
}));

export const StyledSectionContainer = styled(FlexBox)(() => ({
  flexDirection: "column",
  flex: 1,
}));

export const StyledCategoryTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h6,
  alignSelf: "flex-start",
  marginBottom: "8px",
}));

export const StyledGroupedContentContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.grey[200],
  borderRadius: "8px",
  padding: "16px",
  width: "100%",
  height: "auto",
  minHeight: "320px",
  maxHeight: "550px",
  overflowY: "auto",
  marginBottom: "24px",
}));

export const StyledGroupedContent = styled(Stack)(() => ({}));

export const StyledContent = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  whiteSpace: "pre-wrap",
  marginBottom: 0,
}));

export const StyledQuestionList = styled(FlexBox)(() => ({
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "22px",
}));

export const StyledQuestionContent = styled(Stack)(() => ({}));

export const StyledOptionsList = styled(Stack)(() => ({}));

export const StyledDivider = styled(Divider)(() => ({
  margin: "12px 0",
}));

export const StyledPrimaryButton = styled(Button)(({ theme }) => ({
  ...theme.typography.h6,
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  padding: "8px 16px",
  borderRadius: "6px",
  alignSelf: "flex-end",

  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
  },
}));
